import infraMonitor from './reducers';
export default infraMonitor;



// WEBPACK FOOTER //
// ./src/infraMonitor/index.js